import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
} from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'

import PriceContext from '../../../../shared/contexts/PriceContext'
import { EclipseStep } from '../../../../shared/components/StepIcon'

import { useAlert } from '../../../../shared/components'

import Insured from './fragments/Insured'
import Requester from './fragments/Requester'
import ObjectProperty from './fragments/ObjectProperty'
import FileUpload from './fragments/FileUpload'
import StepperQuotation from '../StepperQuotation'

import InsuredData from '../../../../models/BidModels/InsuredData'
import RequesterData from '../../../../models/BidModels/RequesterData'
import ObjectPropertyData from '../../../../models/BidModels/ObjectPropertyData'
import FileUploadData from '../../../../models/BidModels/FileUploadData'

const StepType = {
  INSURED_BID: 0,
  OBJECT_PROPERTY_BID: 1,
  REQUESTER: 2,
  FILE_UPLOAD: 3,
}

const GuaranteeBID = () => {
  const { Provider } = PriceContext

  const history = useHistory()
  const { state } = useLocation()

  const { addMsgDanger: addMsgError, addMsgSuccess } = useAlert()
  const { addMsgDanger, cleanMsg } = useAlert('register')

  const [steps] = useState([
    StepType.INSURED_BID,
    StepType.OBJECT_PROPERTY_BID,
    StepType.REQUESTER,
    StepType.FILE_UPLOAD,
  ])
  const [stepsRef, setStepsRef] = useState({})
  const [actionNext, setActionNext] = useState(false)
  const [quoteEditData, setQuoteEditData] = useState({})
  const [actionPrevious, setActionPrevious] = useState(false)
  const [isFormikChanged, setIsFormikChanged] = useState(false)
  const [activeStep, setActiveStep] = useState(StepType.INSURED_BID)
  const [guaranteeBID, setGuaranteeBID] = useState({})

  const InsuredBidRef = useRef()
  const ObjectPropertyBidRef = useRef()
  const RequesterRef = useRef()
  const FileUploadRef = useRef()

  useEffect(() => {
    const stepsControl = {}
    stepsControl[StepType.INSURED_BID] = InsuredBidRef
    stepsControl[StepType.OBJECT_PROPERTY_BID] = ObjectPropertyBidRef
    stepsControl[StepType.REQUESTER] = RequesterRef
    stepsControl[StepType.FILE_UPLOAD] = FileUploadRef

    setStepsRef(stepsControl)
  }, [setStepsRef, InsuredBidRef, ObjectPropertyBidRef, RequesterRef, FileUploadRef])

  const setDataCamelCase = useCallback((quote) => {
    setGuaranteeBID({
      insured: InsuredData(quote?.Insured),
      requester: RequesterData(quote?.Requester),
      objectProperty: ObjectPropertyData(quote?.ObjectProperty),
      fileUpload: FileUploadData(quote?.FileUpload),
    })
  }, [setGuaranteeBID])

  useEffect(() => {
    if (state?.quote) {
      setDataCamelCase({ ...state?.quote })
      setQuoteEditData({ ...state?.quote })
      setActiveStep(steps[steps.length - 1])
    }
  }, [state, steps, setActiveStep, setQuoteEditData, setDataCamelCase])

  const isActiveStep = (step) => activeStep === step

  const handleNext = () => {
    const stepRef = stepsRef[activeStep]
    stepRef.current.onSubmit().then((data) => {
      if (data) {
        addMsgDanger(data)
      } else {
        setActionNext(true)
        setActionPrevious(false)
      }
    })
  }

  const onNext = () => {
    cleanMsg()
    if (steps.includes(activeStep + 1)) {
      setActiveStep(activeStep + 1)
    }
  }

  const onPrevious = () => {
    cleanMsg()
    setActiveStep(activeStep - 1)
  }

  const onEdit = (step) => {
    setActiveStep(step)

    cleanMsg()
    setActionNext(false)
    setActionPrevious(true)
  }

  const onRegister = (data) => {
    const dataSuccess = {
      title: data?.Title,
      message: data?.Message,
      labelButton: 'Acompanhe sua cotação',
      action: () => history.replace(`/cotacao/${data?.Identifier}/status`),
    }

    addMsgSuccess(dataSuccess)
  }

  const handleRegister = () => {
    const stepRef = stepsRef[activeStep]
    stepRef.current.onSubmit().then((data) => {
      addMsgError(data)
      if (!data) {
        onEdit(StepType.REQUESTER)
      }
    })
  }
  const setFormikChanged = (isChanged) => {
    if (!isFormikChanged) {
      setIsFormikChanged(isChanged)
    }
  }

  return (
    <Provider value={{
      guaranteeBID,
      setGuaranteeBID,
      actionNext,
      actionPrevious,
      onNext,
      onRegister,
      addMsgError,
      isFormikChanged,
      setFormikChanged,
    }}
    >
      {/* STEPS */}
      <StepperQuotation steps={steps} EclipseStep={EclipseStep} activeStep={activeStep} />

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Insured
            quote={quoteEditData}
            ref={stepsRef[StepType.INSURED_BID]}
            checked={isActiveStep(StepType.INSURED_BID)}
            handleNext={handleNext}
            handlePrevious={() => history.goBack()}
            handleStep={() => onEdit(StepType.INSURED_BID)}
          />
        </Grid>
        <Grid item xs={12}>
          <ObjectProperty
            quote={quoteEditData}
            ref={stepsRef[StepType.OBJECT_PROPERTY_BID]}
            checked={isActiveStep(StepType.OBJECT_PROPERTY_BID)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={() => onEdit(StepType.OBJECT_PROPERTY_BID)}
          />
        </Grid>
        <Grid item xs={12}>
          <Requester
            quote={quoteEditData}
            ref={stepsRef[StepType.REQUESTER]}
            checked={isActiveStep(StepType.REQUESTER)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={() => onEdit(StepType.REQUESTER)}
          />
        </Grid>
        <Grid item xs={12}>
          <FileUpload
            quote={quoteEditData}
            ref={stepsRef[StepType.FILE_UPLOAD]}
            checked={isActiveStep(StepType.FILE_UPLOAD)}
            handleNext={handleNext}
            handlePrevious={onPrevious}
            handleStep={handleRegister}
          />
        </Grid>
      </Grid>
    </Provider>
  )
}

export default GuaranteeBID
